/**
 * Base for all dialogs and connector to the
 * dialog stack manager.
 *
 * @author bgr
 */

import { html, render, nothing } from "lit-html";
import { addLayer, removeLayer } from "./StackManager";
import { checkVisibility } from "@escapio/shared/event/visibility-observer";

export class Base {
	constructor() {
		this.shown = false;
		this.attached = false;
		this.node = document.createElement("div");
		this.node.classList.add("dialog");
	}

	render() {
		render(this.getTemplate(), this.node, { host: this });
	}

	connectedCallback() {}

	/**
	 * @param {*} zIndex optional: if passed used as zIndex for dialog and no extra layer is created
	 */
	show(zIndex = null) {
		if (this.shown) {
			return;
		}
		this.shown = true;

		this.render();
		if (!this.attached) {
			document.body.appendChild(this.node);
			this.attached = true;
			this.connectedCallback();
		}

		// Wait to get css ready for transition.
		setTimeout(() => {
			if (zIndex) {
				this.node.style.zIndex = zIndex;
			} else {
				addLayer(this.node, () => this.hide());
			}

			this.node.classList.add("dialog--show");
			// Wait until transition ended.
			const handler = () => {
				this.onShow();
				checkVisibility();
				this.node.removeEventListener("transitionend", handler);
			};
			this.node.addEventListener("transitionend", handler);
		}, 0);
	}

	onShow() {
		// Do stuff when dialog became visible here.
	}

	hide() {
		if (!this.shown) {
			return;
		}
		this.shown = false;
		this.node.classList.remove("dialog--show");
		removeLayer(this.node);
		this.node.dispatchEvent(new CustomEvent("close"));
	}

	getTemplate() {
		return html`
			<div class="dialog__header">
				<div class="dialog__header-left">${this.getTemplateHeaderLeft()}</div>
				<div class="dialog__header-middle">
					${this.getTemplateHeaderMiddle()}
				</div>
				<div class="dialog__header-right">${this.getTemplateHeaderRight()}</div>
			</div>
			<div class="dialog__content">${this.getTemplateContent()}</div>
			${this.getTemplateFooter()}
		`;
	}

	getTemplateHeaderLeft() {
		return nothing;
	}

	getTemplateHeaderMiddle() {
		return nothing;
	}

	getTemplateHeaderRight() {
		return html`<button
			class="dialog__header-close close-icon close-icon--with-hover"
			@click=${this.hide}
		></button>`;
	}

	getTemplateContent() {
		return nothing;
	}

	getTemplateFooter() {
		return nothing;
	}
}
